'use strict';

/**
 * Handler for back button click
 */
function handleBackButtonClick() {
    var referrer = document.referrer || '';
    if (referrer.includes('Checkout')) {
        var homeURL = $('.cart-back').data('home-url') || '/';
        window.location.href = homeURL;
    } else {
        window.history.back();
    }
}

/**
 * Initializes custom cart events
 */
function initCartEvents() {
    $('.cart-back').on('click', handleBackButtonClick);
}

module.exports = {
    initCartEvents: initCartEvents
}
